import React, { useState } from 'react'
import { Col, Row } from 'reactstrap'
import { ApplePlayText, LiveOrgPrice, OrderActionButton, OrderPara, OrdersButton, ProdCardName } from '../../../../StyledComponents'
import tshirt from '../../../../assets/images/dummyImages/t-shirt-1.jpg'
import { Stepper } from 'react-form-stepper'
import TrackOrder from '../../../../assets/images/icons/trackOrder1.png'
import ProductReviewForm from '../ProductReviewForm/ProductReviewForm'
import SellerFeedbackForm from '../SellerFeedbackForm/SellerFeedbackForm'
// import CancelOrder from './CancelOrder';
import PopupModal from '../../../Manage/PopupModal'
import styles from '../Orders.module.scss'


const orders = [
  {
    orderId: "#12345",
    orderPlacedDate: "30/04/2024",
    delivered: "06/05/2024",
    paymentAmount: "$33.99",
    paymentMethod: "COD",
    paymentStatus: "Pending",
    orderStatus: "Ready to ship",
    product: {
      image: tshirt,
      name: "Blue colored Shirt",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      materialSize: "Polyester/Small",
      quantity: 1,
      sku: "#123456789"
    }
  },
  {
    orderId: "#12345",
    returnId: "#12345",
    orderPlacedDate: "30/04/2024",
    delivered: "06/05/2024",
    paymentAmount: "$33.99",
    paymentMethod: "COD",
    paymentStatus: "Pending",
    orderStatus: "Return/Refund",
    refundStatus: "Return/Refund",
    product: {
      image: tshirt,
      name: "Blue colored Shirt",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      materialSize: "Polyester/Small",
      quantity: 1,
      sku: "#123456789"
    }
  },
  // Add more orders as needed
];



const ToBeReviewed = () => {
  const [openTrack, setOpenTrack] = useState(null); // Initialize state with false for each order

  const steps = [{ label: 'Order Received' }, { label: 'Ready to Ship' }, { label: 'Shipped' }, { label: 'In Transit' }, { label: 'Delivered' }]

  const toggleTrackOrder = (index) => {
    setOpenTrack(openTrack === index ? null : index); // Set the index or close the currently open tracking details
  };

  const [data, setData] = useState([]);
  const [name, setName] = useState([]);


  const [showForm, setShowForm] = useState(false);

  const handleAdd = () => {
    setShowForm(false);
  };

  const clickHandler = (name, data) => {
    setShowForm(true);
    setData(data)
    setName(name)
  };


  const [openName, setOpenName] = useState('')
  const [modal, setModal] = useState(false);
  const handleModal = () => setModal(!modal);

  const clickOpenModal = (name, data) => {
    setModal(true)
    console.log('NAME', name, data)
    setOpenName(name)
    setData(data)

  }
  return (
    <>
      {showForm ? (
        <>
          {
            name == 'Write Product Review' ?
              <ProductReviewForm onSwitchTab={''} data={data} showState={handleAdd} onCancel={() => setShowForm(false)} />
              : name == 'Give Seller Feedback' ?
                <SellerFeedbackForm onSwitchTab={''} data={data} showState={handleAdd} onCancel={() => setShowForm(false)} />
                : ""
          }

        </>
      ) : (
        <div>
          {orders.map((order, index) => (
            <div key={index}>
              <div className={styles["order-container"]}>
                <div className={styles["order-item"]}>Order ID: {order.orderId}</div>
                <div className={styles["order-item"]}>
                  <div className={styles["order-info"]}>
                    <div className={styles["info-title"]}>Order Placed</div>
                    <div className={styles["info-content"]}>{order.orderPlacedDate}</div>
                  </div>
                </div>
                <div className={styles["order-item"]}>
                  <div className={styles["order-info"]}>
                    <div className={styles["info-title"]}>Expected Delivery</div>
                    <div className={styles["info-content"]}>{order.expectedDelivery}</div>
                  </div>
                </div>
                <div className={styles["order-item"]}>
                  <div className={styles["order-info"]}>
                    <div className={styles["info-title"]}>Payment</div>
                    <div className={styles["info-content"]}>{order.paymentAmount}</div>
                  </div>
                </div>
                <div className={styles["order-item"]}>
                  <div className={styles["order-info"]}>
                    <div className={styles["info-title"]}>Payment Method</div>
                    <div className={styles["info-content"]}>{order.paymentMethod}</div>
                  </div>
                </div>
                <div className={styles["order-item"]}>
                  <div className={styles["order-info"]}>
                    <div className={styles["info-title"]}>Payment Status</div>
                    <div className={styles["info-content"]}>{order.paymentStatus}</div>
                  </div>
                </div>
                <div className={styles["order-item"]}>
                  <div className={styles["order-info"]}>
                    <div className={styles["info-title"]}>Order Status</div>
                    <div className={styles["info-content"]}>{order.orderStatus}</div>
                  </div>
                </div>
              </div>
              {openTrack === index ?
                <>
                  <div className='d-flex flex-row p-4'>
                    <img src={TrackOrder} />
                    <Stepper
                      style={{ width: '100%' }}
                      steps={steps}
                      activeStep={1}
                      connectorStateColors={true}
                      connectorStyleConfig={{
                        completedColor: '#ffbd13',
                        activeColor: '#ffbd13',
                        disabledColor: '#eee'
                      }}
                      styleConfig={{
                        activeBgColor: '#ffd813',
                        completedBgColor: '#ffbd13',
                        inactiveBgColor: '#eee',
                        activeTextColor: '#111',
                        completedTextColor: '#222',
                        inactiveTextColor: '#444',
                        circleFontSize: '0',
                      }}
                    />
                  </div>
                </> : ""
              }
              <Row className='my-3'>

                <Col>
                  <div className='d-flex flex-column flex-md-row gap-2'>

                    <div className='text-center'><img src={order.product.image} width={155} height={138} className='img-fluid' /></div>

                    <div className='d-flex flex-column'>
                      <div className='flex-grow-1'>
                        <div className='fw-semibold'>{order.product.name}</div>
                        <div>{order.product.description}</div>
                        <div className={styles['font-sm']}>
                          <div>
                            <span className='fw-medium me-3'>{order.product.materialSize}</span>
                            <span><span className='fw-medium'>Qty:</span> {order.product.quantity}</span>
                          </div>
                          <div>
                            <span className='fw-medium me-2'>Product SKU:</span>
                            <span>{order.product.sku}</span>
                          </div>
                        </div>
                      </div>
                      <div className='d-flex gap-2'>
                        <div className={styles['buy-again-button']}>Buy Again</div>
                        <div className={styles['view-product-button']}>View Product</div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs='0' md='2'>
                <div className={`${styles['action-buttons']} mt-3 mt-md-0`}>

                    <div className={`${styles['action-button']} cursor-pointer`} onClick={() => toggleTrackOrder(index)}>Track Order</div>
                    <div className={`${styles['action-button']} cursor-pointer`} onClick={() => clickOpenModal('Cancel Order', "")}>Cancel Order</div>
                    <div className={`${styles['action-button']} cursor-pointer`} onClick={() => clickHandler("Write Product Review", order)}>Write Product Review</div>
                    <div className={`${styles['action-button']} cursor-pointer`} onClick={() => clickHandler("Give Seller Feedback", order)}>Give Seller Feedback</div>

                  </div>
                </Col>

              </Row>
            </div>
          ))}
        </div>

      )}

      <PopupModal
        company_id={''}
        open={modal}
        setModal={setModal}
        handleModal={handleModal}
        name={openName}
        tableData={""}
        setTableData={''}
      />
    </>
  );
}

export default ToBeReviewed
